import Configs from "../config";
import {
  ICreateLearnisticIntegrationIRoute,
  ILearnisticApp,
  ILearnisticIntegration,
  IUpdateLearnisticIntegrationIRoute,
} from "../generated/Api";
import { DefaultResponse } from "../types/UtilTypes";
import { localStorageGetItem } from "../utils/LocalStorage";

export const createLearnisticIntegration = async (
  data: Omit<ICreateLearnisticIntegrationIRoute, "userUid">
): Promise<ILearnisticIntegration> => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Configs.SERVER_URL}/learnistic`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({
      ...data,
      userUid,
    }),
  });

  const integration: DefaultResponse<ILearnisticIntegration> =
    await response.json();
  if (integration.status === "ok") {
    return integration.data as ILearnisticIntegration;
  }

  throw new Error(integration.code);
};

export const setAppsLearnisticIntegration = async (
  data: Omit<IUpdateLearnisticIntegrationIRoute, "userUid">
): Promise<ILearnisticIntegration> => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Configs.SERVER_URL}/learnistic/${userUid}`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({
      ...data,
    }),
  });

  const integration: DefaultResponse<ILearnisticIntegration> =
    await response.json();
  if (integration.status === "ok") {
    return integration.data as ILearnisticIntegration;
  }

  throw new Error(integration.code);
};

export const getAllApps = async (): Promise<ILearnisticApp[]> => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/learnistic/apps/${userUid}`,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );

  const integration: DefaultResponse<ILearnisticApp[]> = await response.json();
  if (integration.status === "ok") {
    return integration.data as ILearnisticApp[];
  }

  return [];
};

export const updateLearnisticContacts = async (): Promise<ILearnisticApp[]> => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/learnistic/updateContacts/${userUid}`,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );

  const integration: DefaultResponse<ILearnisticApp[]> = await response.json();
  if (integration.status === "ok") {
    return integration.data as ILearnisticApp[];
  }

  return [];
};

export const getAllAppsTags = async (): Promise<ILearnisticApp[]> => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/learnistic/tags/${userUid}`,
    { headers: { Authorization: "Bearer " + token } }
  );

  const integration: DefaultResponse<ILearnisticApp[]> = await response.json();
  if (integration.status === "ok") {
    return integration.data as ILearnisticApp[];
  }

  throw new Error(integration.code);
};

export const deleteLearnisticIntegration = async (): Promise<boolean> => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Configs.SERVER_URL}/learnistic/${userUid}`, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
      Authorization: "Bearer " + token,
    },
  });

  const integration: DefaultResponse<ILearnisticIntegration> =
    await response.json();
  if (integration.status === "ok") {
    return true;
  }

  throw new Error(integration.code);
};
